export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11396.30184082.jpg";